import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">关于吃瓜群的常见问题解答</p>
        </div>

        <div className="max-w-[720px] mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800" style={{ fontFamily: 'var(--font-heading)' }}>
                  {item.q}
                </h3>
                <i className={`flex-shrink-0 text-lg text-foreground-400 transition-transform duration-200 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}